<template>
	<div class="wizard-component">
		<div>
			<p class="subject">{{$t('withoutnemid.upload.headline')}}</p>
			<p>{{$t('withoutnemid.upload.text')}}</p>
		</div>


		<!-- 1. Hvis en fil er uploadet -->
		<div v-if="verificationFile" class="uploaded-item">
            <div class="file-name">{{verificationFile}} </div>
            <div class="delete-item" @click.prevent="deleteVerificationFile()"><img src="/images/SVG/Delete.svg"></div>
        </div>
        <div v-else>
            <Upload uri="/user/document" v-on:success="onSuccess()" :parameters="parameters" />
        </div>
		<div>
			<p class="subject">{{$t('withoutnemid.info.headline')}}</p>
			<p>{{$t('withoutnemid.info.text')}}</p>
		</div>
		<form class="inputs">
			<div class="input-container">
				<input type="text" v-model="info.firstName" autofill="off" autocomplete="false" :placeholder="$t('input.placeholder.first-name')" />
			</div>
			<div class="input-container">
				<input type="text" v-model="info.lastName" autofill="off" autocomplete="false" :placeholder="$t('input.placeholder.last-name')" />
			</div>

			<div class="input-container double">
				<div class="select-container">
					<select v-model="info.gender" v-bind:class="info.gender">
						<option value disabled>{{ $t('input.placeholder.gender') }}</option>
						<option value="M">{{ $t('gender.label.male') }}</option>
						<option value="F">{{ $t('gender.label.female') }}</option>
					</select>
					<span class="icon">
	                    <SvgIcon icon="select-arrow" />
	                </span>
				</div>
			</div>
			<div class="input-container double">
				<div class="input-inner date-input">
					<DateTimeInput
                        id="dob"
                        :time="false"
                        :value="info.dob" />
					<!-- <input type="date"  v-model="info.dob" /> -->
					<span class="label-after">
                        <SvgIcon icon="calendar" />
                    </span>
				</div>
			</div>

			<div class="input-container">
				<input type="text" v-model="info.address" autofill="off" autocomplete="false" :placeholder="$t('input.placeholder.address')" />
			</div>
			<div class="input-container double">
				<input type="text" v-model="info.zipcode" autofill="off" autocomplete="false" :placeholder="$t('input.placeholder.zipcode')" />
			</div>
			<div class="input-container double">
				<input type="text" v-model="info.city" autofill="off" autocomplete="false" :placeholder="$t('input.placeholder.city')" />
			</div>
			<div class="input-container">
				<input type="text" v-model="info.country" autofill="off" autocomplete="false" :placeholder="$t('input.placeholder.country')" />
			</div>
			<div>
				<button class="purple" v-on:click="updateExpatVerification()">{{ $t('button.continue') }}</button>
			</div>
		</form>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	import Upload from '../../../components/Upload.vue';
	import SvgIcon from '../../../components/Svg.vue';
	import DateTimeInput from '../../../components/DateTimeInput.vue';


	export default {
		components: {
			Upload,
			SvgIcon,
			DateTimeInput
		},
		computed: {
			...mapGetters([
				'getToken'
			])
		},
		data: () => ({
			showEditor: false,
			verificationFile: false,
			parameters: {
				type: 'verification'
			},
			info: {
				firstName: '',
				lastName: '',
				dob: '',
				country: '',
				zipcode: '',
				city: '',
				address: '',
				gender: ''

			}
		}),
		methods: {

			onSuccess() {
				this.showEditor = true;
				this.load();
			},
			updateExpatVerification() {
				axios({
                    method: 'PUT',
                    url: window.config.apiUrl + 'api/screening/verification',
					cancelToken: window.AuthorizationCancelSource.token,
                    data: this.info
                }).then(response => {
                	this.$store.commit('setSuccessBarMessage', this.$t('success-message.saved.label'));
                    this.$root.$emit('verificationCompleted');
                    this.$store.dispatch('fetchUserData');
                });
			},
			deleteVerificationFile() {
				axios({
                    method: 'DELETE',
                    url: window.config.apiUrl + 'api/screening/verification',
					cancelToken: window.AuthorizationCancelSource.token,
                    data: this.info
                }).then(response => {
                	this.verificationFile = false;
                });
			},
			load() {
				axios({
	                method: 'POST',
	                url: window.config.apiUrl + 'api/user/info',
					cancelToken: window.AuthorizationCancelSource.token,
	            }).then(response => {
	                var userInfo = response.data.userInfo;

	                if (userInfo.full_name) {
		                var name = userInfo.full_name.split(' ');
		                var firstName = '';
		                for (var i in name) {
		                	if (i <= name.length - 2) {
		                		firstName += (firstName ? ' ' : '') + name[i];
		                	}
		                }
		                var lastName = name[name.length - 1];

		                this.info.firstName = firstName;
		                this.info.lastName = lastName;
		            }

	                this.verificationFile = response.data.verificationFile;
	                this.info.dob = userInfo.date_of_birth;
	                this.info.address = userInfo.address;
	                this.info.zipcode = userInfo.zipcode;
	                this.info.country = userInfo.country;
	                this.info.gender = userInfo.gender;
	                this.info.city = userInfo.city;
	            });
			}
		},
		created() {
			this.load();
		}
	}
</script>
